import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { DescriptionRow } from 'components';
import { TranslationNamespace } from 'i18n';

type Props = {
  credentials?: Record<string, any>;
};

export const P2PProviderCredentialsDetails: React.FC<Props> = ({
  credentials,
}) => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'pages.p2p_providers',
  });
  const { t: tCommon } = useTranslation(TranslationNamespace.Common);

  return (
    <Fragment>
      {credentials?.apiKey && (
        <DescriptionRow
          title={t('details.api_key')}
          value={credentials.apiKey}
          canCopy
          secret
        />
      )}
      {credentials?.signatureKey && (
        <DescriptionRow
          title={t('details.signature_key')}
          value={credentials.signatureKey}
          canCopy
          secret
        />
      )}
      {credentials?.apiToken && (
        <DescriptionRow
          title={t('details.api_token')}
          value={credentials.apiToken}
          canCopy
          secret
        />
      )}
      {credentials?.webhookAmountField && (
        <DescriptionRow
          title={t('details.webhook_amount_field')}
          value={credentials.webhookAmountField}
        />
      )}
      {credentials?.webhookSecret && (
        <DescriptionRow
          title={t('details.webhook_secret')}
          value={credentials.webhookSecret}
          canCopy
          secret
        />
      )}
      {credentials?.host2host && (
        <DescriptionRow
          title={t('details.host_2_host')}
          value={credentials.host2host}
          canCopy
        />
      )}
      {credentials?.apiPublic && (
        <DescriptionRow
          title={t('details.api_public')}
          value={credentials.apiPublic}
          canCopy
        />
      )}
      {credentials?.apiPrivate && (
        <DescriptionRow
          title={t('details.api_private')}
          value={credentials.apiPrivate}
          canCopy
          secret
        />
      )}
      {credentials?.clientId && (
        <DescriptionRow
          title={t('details.client_id')}
          value={credentials.clientId}
          canCopy
        />
      )}
      {credentials?.apiSecret && (
        <DescriptionRow
          title={t('details.api_secret')}
          value={credentials.apiSecret}
          canCopy
          secret
        />
      )}
      {credentials?.privateKey && (
        <DescriptionRow
          title={t('details.private_key')}
          value={credentials.privateKey}
          canCopy
          secret
        />
      )}
      {credentials?.password && (
        <DescriptionRow
          title={t('details.password')}
          value={credentials.password}
          canCopy
          secret
        />
      )}
      {credentials?.login && (
        <DescriptionRow
          title={t('details.login')}
          value={credentials.login}
          canCopy
        />
      )}
      {credentials?.contractId && (
        <DescriptionRow
          title={t('details.contract_id')}
          value={credentials.contractId}
          canCopy
        />
      )}
      {credentials?.merchantId && (
        <DescriptionRow
          title={t('details.merchant_id')}
          value={credentials.merchantId}
          canCopy
        />
      )}
      {credentials?.accessTokenPayin && (
        <DescriptionRow
          title={t('details.access_token_payin')}
          value={credentials.accessTokenPayin}
          canCopy
          secret
        />
      )}
      {credentials?.accessTokenPayout && (
        <DescriptionRow
          title={t('details.access_token_payout')}
          value={credentials.accessTokenPayout}
          canCopy
          secret
        />
      )}
      {credentials?.customerUUID && (
        <DescriptionRow
          title={t('details.customer_uuid')}
          value={credentials.customerUUID}
          canCopy
        />
      )}
      {credentials?.clientCodeName && (
        <DescriptionRow
          title={t('details.client_code_name')}
          value={credentials.clientCodeName}
          canCopy
        />
      )}
      {credentials?.apiTokenPayoutSbp && (
        <DescriptionRow
          title={t('details.api_token_payout_sbp')}
          value={credentials.apiTokenPayoutSbp}
          canCopy
          secret
        />
      )}
      {credentials?.apiTokenPayoutCard && (
        <DescriptionRow
          title={t('details.api_token_payout_card')}
          value={credentials.apiTokenPayoutCard}
          canCopy
          secret
        />
      )}
      {credentials?.authToken && (
        <DescriptionRow
          title={t('details.auth_token')}
          value={credentials.authToken}
          canCopy
          secret
        />
      )}
      {credentials?.accountId && (
        <DescriptionRow
          title={t('details.account_id')}
          value={credentials.accountId}
          canCopy
        />
      )}
      {credentials?.shopId && (
        <DescriptionRow
          title={t('details.shop_id')}
          value={credentials.shopId}
          canCopy
        />
      )}
      {credentials?.isFtd && (
        <DescriptionRow
          title={t('details.is_ftd')}
          value={tCommon('common.yes')}
        />
      )}
      {credentials?.username && (
        <DescriptionRow
          title={t('details.username')}
          value={credentials.username}
          canCopy
        />
      )}
      {credentials?.secret_key && (
        <DescriptionRow
          title={t('details.secret_key')}
          value={credentials.secret_key}
          canCopy
          secret
        />
      )}
      {credentials?.userId && (
        <DescriptionRow
          title={t('details.user_id')}
          value={credentials.userId}
          canCopy
        />
      )}
      {credentials?.uid && (
        <DescriptionRow
          title={t('details.uid')}
          value={credentials.uid}
          canCopy
        />
      )}
      {credentials?.email && (
        <DescriptionRow
          title={t('details.email')}
          value={credentials.email}
          canCopy
        />
      )}
      {credentials?.tokenPublic && (
        <DescriptionRow
          title={t('details.token_public')}
          value={credentials.tokenPublic}
          canCopy
        />
      )}
      {credentials?.tokenPrivate && (
        <DescriptionRow
          title={t('details.token_private')}
          value={credentials.tokenPrivate}
          canCopy
          secret
        />
      )}
      {credentials?.accessToken && (
        <DescriptionRow
          title={t('details.access_token')}
          value={credentials.accessToken}
          canCopy
          secret
        />
      )}
    </Fragment>
  );
};
